import CrudTemplate from "../crudTemplate";
import SubCanalService from "../../services/resource/subCanalService";

export default function SubCanalCrud() {
    const service = new SubCanalService();

    const formFields = [
        { name: "id", label: "ID", type: "input", disabled: true, typeText: "number", colSpan: 1 },
        { name: "nome", label: "Nome", type: "input", colSpan: 2 },
    ];

    const tableColumns = [
        { key: "nome", label: "Nome", bold: true },
        { key: "ativo", label: "Ativo", render: v => v ? "Sim" : "Não" },
    ];

    return <CrudTemplate
        title="Gerenciar SubCanais"
        formFields={formFields}
        tableColumns={tableColumns}
        service={service}
        style={{ width: '85%' }}
        modalHeader="SubCanal"
    />;
}
